import type { Goal } from '../services/goalService';

const time = (value?: string | null): number => (value ? new Date(value).getTime() || 0 : 0);

/** updatedAt (server T-115), or createdAt from a server without it. */
export const lastUpdated = (goal: Pick<Goal, 'updatedAt' | 'createdAt'>): number =>
  time(goal.updatedAt) || time(goal.createdAt);

/** The most recently updated goal first, the newest created breaking ties (T-118, as GET /goals). */
export const compareLastUpdated = (a: Goal, b: Goal): number =>
  lastUpdated(b) - lastUpdated(a) || time(b.createdAt) - time(a.createdAt);

/** A content edit made here moves the goal to the top at once, as the server will (T-118). */
export const touched = <T extends Goal>(goal: T): T => ({ ...goal, updatedAt: new Date().toISOString() });
